import BResultsNutrition from './BResultsNutrition'

export default BResultsNutrition
